import cn from 'classnames/bind'

import toFixedValue from 'app/common/lib/toFixedValue'

import styles from './Cell.scss'

const cx = cn.bind(styles)

type Props = {
  children: number
}

export const Cell = ({ children }: Props) => {
  const value = toFixedValue(children)

  return <span className={cx({ zero: children === 0 })}>{value}</span>
}
